// extracted by mini-css-extract-plugin
export default {"wrapper":"jwhJP","infoBlocks":"tsLHQ ZdH1P","products":"GljxN"};